import { useCallback } from "react";

import { runInAction } from "mobx";

import { useStore } from "@/store";
import { getIsMobile } from "@/utils/getIsMobile";

import type { HintKey, HintParams } from "@/store/HintsStore";

type UseHintHandlers = {
  onMouseEnter: (e: React.MouseEvent) => void;
  onMouseLeave: (e: React.MouseEvent) => void;
};

export function useCreateHintHoverHandlers() {
  const { hints, view } = useStore();

  const createHandlers = useCallback(
    (hintKey: HintKey, params: HintParams = {}): UseHintHandlers => {
      const isMobile = getIsMobile();

      function handleOnMouseEnter() {
        if (!view.isHintsPanelVisible || isMobile) {
          return;
        }

        runInAction(() => {
          hints.hint = { key: hintKey, params };
        });
      }

      function handleOnMouseLeave() {
        if (!view.isHintsPanelVisible || isMobile) {
          return;
        }

        runInAction(() => {
          hints.hint = null;
        });
      }

      return {
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleOnMouseLeave,
      };
    },
    [hints, view],
  );

  return createHandlers;
}

export function useHintHover(hintKey: HintKey, params: HintParams = {}): UseHintHandlers {
  const createHandlers = useCreateHintHoverHandlers();
  return createHandlers(hintKey, params);
}
